import { useState } from 'react';
import { IconButton } from '@mui/material';
import { Delete } from '@mui/icons-material';
import Box from '@mui/material/Box';
import { useDelete, useNotify } from 'react-admin';
import { AVATARS } from '@/utils/CONST';
import DeleteDialog from '@/components/common/delete-dialog/delete-dialog';
import { Avatar } from '@/utils/types';

interface Props {
    avatar: Avatar;
    withDelete?: boolean;
}

const AvatarActionField = ({ avatar, withDelete }: Props) => {
    const [deleteOne, { isLoading }] = useDelete();
    const notify = useNotify();
    const [openDeleteModal, setOpenDeleteModal] = useState(false);

    const handleDeleteOne = () => {
        deleteOne(
            AVATARS,
            {
                id: avatar.id,
                meta: {
                    requestType: 'update',
                    id: `${avatar.id}/enable`,
                    data: {
                        enabled: false,
                        children: false,
                    },
                },
            },
            {
                onSuccess: () => {
                    notify('ra.notification.deleted', {
                        type: 'success',
                        messageArgs: {
                            smart_count: 1,
                        },
                    });
                    setOpenDeleteModal(false);
                },
                mutationMode: 'optimistic',
            },
        );
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'end',
                gap: 1,
            }}
        >
            {/* {mc && (
                <IconButton
                    disabled={isLoading}
                    onClick={() => handleSimulateApp(mc)}
                    color={'primary'}
                    sx={{
                        p: 0.5,
                    }}
                >
                    <OpenInNewIcon />
                </IconButton>
            )} */}

            {withDelete && (
                <IconButton
                    disabled={isLoading}
                    onClick={() => setOpenDeleteModal(true)}
                    color={'primary'}
                    sx={{
                        p: 0.5,
                    }}
                >
                    <Delete />
                </IconButton>
            )}

            {withDelete && openDeleteModal && (
                <DeleteDialog
                    isLoading={isLoading}
                    onClose={() => setOpenDeleteModal(false)}
                    onClick={handleDeleteOne}
                />
            )}
        </Box>
    );
};

export default AvatarActionField;
